import ReactGA4 from "react-ga4";

// Log page views
export const logPageView = (url: string) => {
	ReactGA4.send({ hitType: "pageview", page: url });
};
